import script from "./loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./loader.vue?vue&type=script&setup=true&lang=ts"

import "./loader.vue?vue&type=style&index=0&id=dc538026&scoped=true&lang=scss"

import exportComponent from "/home/orynik/Documents/source/personal/trainer-blind-print/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc538026"]])

export default __exports__